module.exports = __webpack_public_path__ + "34273e53d9b7aedafcf72a3ebf4427e8.svg";